import { Routes, Route } from 'react-router-dom'
import RoomPage from './pages/RoomPage'
import AdminDashboard from './pages/AdminDashboard'
import HomePage from './pages/HomePage'
import { useAuth } from './contexts/AuthContext'

function App() {
  const { isAuthenticated, loading } = useAuth()

  if (loading) {
    return (
      <div className="container">
        <div className="card" style={{ textAlign: 'center', marginTop: '4rem' }}>
          <h1>Loading...</h1>
          <div style={{ marginTop: '2rem' }}>
            <div style={{ 
              width: '40px', 
              height: '40px', 
              border: '4px solid var(--border-color)',
              borderTop: '4px solid var(--primary-color)',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
              margin: '0 auto'
            }}></div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/room/:roomId" element={<RoomPage />} />
      <Route path="/dashboard/*" element={
        isAuthenticated ? <AdminDashboard /> : <HomePage />
      } />
    </Routes>
  )
}

export default App